import { Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";

const DashboardLayout = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="layout-width">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
